/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "headline_variant_default": "",
  "headline_colors_primary": "text-al-petroleum-600",
  "headline_size_default": "text-al-headline-sm mb-3",
  "description_variant_default": "",
  "description_colors_primary": "",
  "description_size_default": "text-al-paragraph mb-4 sm:mb-8 max-w-article-lg",
  "article_group_variant_default": "grid grid-cols-3 gap-3",
  "article_group_colors_primary": "",
  "article_group_size_default": "pb-3",
  "article_headline_variant_default": "hidden",
  "article_headline_colors_primary": "",
  "article_headline_size_default": "",
  "article_image_variant_default": "",
  "article_image_colors_primary": "",
  "article_image_size_default": "",
  "article_variant_default": "",
  "article_colors_primary": "",
  "article_size_default": "",
  "variant_default": "mx-auto",
  "colors_primary": "",
  "size_default": "py-6 px-3"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "InstagramArticlesList");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;